(function ($) {
  ("use strict");
  Drupal.behaviors.buildTestimonialsSlider = {
    attach: function (context) {
      // Initialize testimonials slider
      $(".testimonials-slider__wrapper").slick({
        autoplay: false,
        speed: 300,
        infinite: true,
        mobileFirst: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        dots: false,
        appendArrows: $(".testimonials-slider__controls"),
      });
    },
  };
})(jQuery);
